import { envConfig, isDesktop } from "./apiEndpoints";
import utility from "../helpers/utility";
import { MINIAPP } from "../helpers/paymentConstants";

let isMiniApp = utility.getMiniAppStorageVal();
isMiniApp = [MINIAPP.GPAY, MINIAPP.PAYTM].includes(isMiniApp) && isMiniApp;

const GOOGLE_MAPS_API_KEY = envConfig?.GOOGLE_MAPS_API_KEY;

const API_KEY = isMiniApp ? envConfig[`${isMiniApp}_API_KEY`] : !isDesktop ? envConfig?.API_KEY : envConfig?.DESKTOP_API_KEY;

const APP_API_KEY = envConfig?.APP_API_KEY;

const clientType = isMiniApp ? envConfig[`${isMiniApp}_CLIENT_TYPE`] : envConfig.CLIENT_TYPE;

const APP_VERSION = window._siteProps_?.props?.app_version;

export default {
  GOOGLE_MAPS_API_KEY,
  API_KEY,
  APP_API_KEY,
  clientType,
  APP_VERSION
};
